import ArtistListApp from "artist/list/app";
import {
  type RouteObject,
} from "react-router";

declare let viewModel: any;

export const artistRoute: RouteObject = {
  path: "artist",
  children: [{
    index: true,
    loader: () => viewModel,
    Component: ArtistListApp,
  }]
};